import { GiftCard, GiftCardReload } from '../models/gift-card.model';

const coinsToInteger = (number: number): number => {
  return number / 100;
};

export const dataToGiftCard = (data: any): GiftCard  => {
  return new GiftCard(
    coinsToInteger(data.balance),
    data.state
  );
};

export const dataToGiftCardReload = (data: any): GiftCardReload => {
  return new GiftCardReload(
    data.id,
    data.type,
    data.balance_money,
    data.gan,
    data.enable_auto_reload,
    data.auto_reload_threshold,
    data.auto_reload_location_id,
    data.auto_reload_amount,
    data.auto_reload_source_id
  );
};


